module.exports = __webpack_public_path__ + "static/media/report1.9e66aa41.xlsx";